export default __webpack_public_path__ + "static/media/avatar_30.84171fdf.png";